import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Dropdown, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type BmwModuleSpecsFragment } from '../../../../api/fragments/BmwModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';

type BmwModuleActionsProps = {
    module: BmwModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};

const BmwModuleAction = ({ module, permissions }: BmwModuleActionsProps) => {
    const { t } = useTranslation(['bmwModuleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasDeletePermission } = permissions;

    const items = [
        hasDeletePermission && {
            label: t('bmwModuleDetails:actions.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <Dropdown menu={{ items }}>
            <Button type="primary">
                <Space>
                    <span>{t('bmwModuleDetails:actions.label')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default BmwModuleAction;
